import { IModel } from "@/@types/models/model";
import { coreFields } from "./helpers/coreFields";

const User: IModel = {
  title: "Photos360",
  apiPath: "photos360",
  forms : {
    "default": {
      fields: ["id", "title"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "title"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Title",
      source: "title",
      ttoken: "data.naziv",
      type: "text",
      validation: {
        maxLength: 100
      }
    }
  ]
}

export default User;
